import {ListItem, WithTestAttributeProps} from 'components';

type Props = {
    children: React.ReactNode;
    className?: string;
    disabled?: boolean;
    selected?: boolean;
    selectable?: boolean;
    hideOnClick?: boolean;
    onClose?: () => void;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & WithTestAttributeProps;

export const DropdownItem: React.FC<Props> = ({hideOnClick, onClose, ...rest}: Props) => (
    <ListItem
        {...rest}
        onClick={(e) => {
            if (hideOnClick) {
                onClose?.();
            }
            rest?.onClick?.(e);
        }}
    />
);
